export default __webpack_public_path__ + "static/media/cx_cover_c40.2bcb903f.jpg";